<div class="popup-overlay" *ngIf="isVisible" (click)="closePopup()">
    <div class="popup-container" (click)="$event.stopPropagation()">
        <!-- Icon cảnh báo -->
        <div class="popup-icon">
            <i class="fas fa-exclamation-triangle"></i>
        </div>

        <!-- Nội dung -->
        <div class="popup-content">
            <h2 class="popup-title">Thông báo tạm ngừng hoạt động</h2>
            <p class="popup-message">
                Do nguồn kinh phí vận hành hiện đã cạn kiệt, chúng tôi buộc phải tạm dừng hoạt động của trang web. Đây là quyết định khó khăn nhưng cần thiết để đảm bảo chất lượng dịch vụ khi có thể trở lại.
            </p>
            <p class="popup-submessage">
                Chúng tôi sẽ khởi động lại hệ thống ngay khi có đủ điều kiện tài chính.
            </p>
            <p class="popup-submessage">
                Trân trọng cảm ơn sự ủng hộ và đồng hành của quý người dùng trong suốt thời gian qua.
            </p>
        </div>

        <!-- Nút đóng -->
        <button class="popup-button" (click)="closePopup()">
            <i class="fas fa-check-circle"></i>
            Đã hiểu
        </button>

        <!-- Nút X đóng ở góc -->
        <button class="popup-close-btn" (click)="closePopup()" aria-label="Đóng">
            <i class="fas fa-times"></i>
        </button>
    </div>
</div>